import {
  Home,
  Settings,
  Users,
  ClipboardCheck,
  FileText,
  User,
  LogOut,
  ShieldCheck,
  Clock,
  Edit,
  HelpCircle,
  Shield,
} from "lucide-react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useAuth } from "@/hooks/auth";
import { useToast } from "@/hooks/use-toast";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import Testing from "../layout/Testsing";

export function HorizontalNavigation() {
  const location = useLocation();
  const { signOut, userProfile } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const { schoolId } = useParams();

  // console.log("schoolId;", schoolId);
  const isAdminAccess = localStorage.getItem("isAdminAccess");

  const navigationItems = [
    { path: "dashboard", label: "الرئيسية", icon: Home },
    { path: "school-settings", label: "الإعدادات", icon: Settings },
    { path: "students", label: "إدارة الطلاب", icon: Users },
    { path: "teachers", label: "إدارة المعلمين", icon: Users },
    { path: "attendance", label: "تسجيل الحضور", icon: ClipboardCheck },
    { path: "late-attendance", label: "تسجيل التأخر", icon: Clock },
    { path: "reports-beta", label: "التقارير", icon: FileText },
    { path: "school-help", label: "المساعدة", icon: HelpCircle },
  ];

  const teachernavs = [
    { path: "attendance", label: "تسجيل الحضور", icon: ClipboardCheck },
    { path: "late-attendance", label: "تسجيل التأخر", icon: Clock },
  ];
  const studentnavs = [
    {
      path: "student-attendance",
      label: "الحضور والغياب",
      icon: ClipboardCheck,
    },
    { path: "student-late-attendance", label: "التأخرات", icon: Clock },
  ];

  const adminNavigationItems = [
    { path: "/admin", label: "لوحة التحكم", icon: ShieldCheck },
    { path: "/content-management", label: "إدارة المحتوى", icon: Edit },
  ];

  const infoItems = [
    { path: "/terms", label: "الشروط والأحكام", icon: FileText },
    { path: "/privacy", label: "سياسة الخصوصية", icon: Shield },
    { path: "/help", label: "المساعدة", icon: HelpCircle },
  ];

  const navsMap = {
    student: studentnavs,
    teacher: teachernavs,
    admin: navigationItems,
    school: navigationItems,
  };

  const currentItems = navsMap[userProfile.role];

  const handleLogout = async () => {
    try {
      await signOut();
      navigate("/auth", { replace: true });
    } catch (error) {
      console.error("Error during logout:", error);
      toast({
        title: "خطأ في تسجيل الخروج",
        description: "حدث خطأ أثناء تسجيل الخروج",
        variant: "destructive",
      });
    }
  };

  const handleReturnToAdminDashboard = () => {
    localStorage.removeItem("isAdminAccess");
    localStorage.removeItem("adminAccessSchool");

    toast({
      title: "تم العودة للوحة التحكم",
      description: "أنت الآن في وضع المدير العام",
    });

    navigate("/admin");
  };

  return (
    <div className="bg-white/90 backdrop-blur-sm border-b shadow-sm" dir="rtl">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          {/* الروابط الرئيسية */}
          <div className="flex items-center gap-1 flex-wrap">
            {currentItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname.split("/").includes(item.path);

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? "bg-school-blue text-white shadow-lg"
                      : "text-gray-600 hover:bg-gray-100 hover:text-school-blue"
                  }`}
                >
                  <Icon className="h-4 w-4" />
                  <span className="hidden sm:block">{item.label}</span>
                </Link>
              );
            })}
          </div>{" "}
          {/* <Testing/> */}
          {/* العودة للوحة التحكم - للمدراء فقط */}
          {userProfile?.role === "admin" && (
            <Button
              onClick={handleReturnToAdminDashboard}
              variant="ghost"
              size="sm"
              className="text-yellow-600 hover:text-yellow-700 hover:bg-yellow-50"
            >
              <ShieldCheck className="h-4 w-4 ml-1" />
              <span className="hidden sm:block">العودة للوحة التحكم</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
